/*
 * MGM Gift — cadeaux popup ajoutés automatiquement au panier.
 *
 * Un "entitlement" est accordé par le popup scratch après capture email
 * (MGMGift.grant). Il est persisté en localStorage puis synchronisé avec le
 * panier : la variante cadeau est ajoutée dès que le produit principal est
 * présent, retirée s'il disparaît. Le passage à 0 € se fait via le code promo
 * Buy X Get Y, appliqué par l'API Cart AJAX une fois le cadeau au panier
 * (fallback cookie /discount/ si l'AJAX échoue).
 */
(function () {
  var STORAGE_KEY = 'mgm_gift_entitlements';
  var DECLINED_KEY = 'mgm_gift_declined';
  var CAMPAGNE_PREFIX = 'cmp-';
  var CODE_PREFIX = 'code-';
  var REFUSED_KEY = 'mgm_gift_code_refused';
  var GIFT_PROP = '_mgm_gift';
  var syncing = null;
  var appliedCodes = {};
  // Ces codes n'offrent l'article que s'il est déjà au panier : Shopify ne l'ajoute jamais lui-même.
  var CODE_GIFTS = {
    VIPFONTAINE: { variantId: '56859530887555', trigger: ['15422505320835'], label: '6 mois de filtres offerts', replaces: 'cmp-filtres' },
    VIPLAMES: { variantId: '57579767169411', trigger: ['15274204725635', '15934488281475'], label: 'Pack de 3 lames offert', hint: 'Ajoutez un article pour recevoir vos lames offertes' }
  };

  function readEntitlements() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  function writeEntitlements(data) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function readDeclined() {
    try {
      return JSON.parse(localStorage.getItem(DECLINED_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function campagneEntitlements() {
    var campagne = window.MGMCampagne;
    var out = {};
    if (!campagne || !campagne.cadeaux) return out;
    var declined = readDeclined();
    campagne.cadeaux.forEach(function (g) {
      out[g.ns] = {
        ns: g.ns,
        variantId: String(g.variantId),
        trigger: g.trigger,
        accept: g.accept.map(String),
        label: g.label,
        declined: !!declined[g.ns]
      };
    });
    return out;
  }

  function readRefused() {
    try {
      return JSON.parse(sessionStorage.getItem(REFUSED_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function payingProducts(cart) {
    var ids = {};
    ((cart && cart.items) || []).forEach(function (it) {
      if (!isGiftItem(it)) ids[it.product_id] = true;
    });
    return Object.keys(ids).sort().join(',');
  }

  function codeEntitlements(cart) {
    var out = {};
    var declined = readDeclined();
    var refused = readRefused();
    var products = payingProducts(cart);
    ((cart && cart.discount_codes) || []).forEach(function (d) {
      var code = String(d.code).toUpperCase();
      var gift = CODE_GIFTS[code];
      if (!gift) return;
      var ns = CODE_PREFIX + code.toLowerCase();
      if (refused[ns] === products) return;
      out[ns] = {
        ns: ns,
        variantId: gift.variantId,
        trigger: gift.trigger,
        accept: [gift.variantId],
        label: gift.label,
        replaces: gift.replaces,
        declined: !!declined[ns]
      };
    });
    return out;
  }

  function allEntitlements(cart) {
    var all = readEntitlements();
    var campagne = campagneEntitlements();
    var codes = codeEntitlements(cart);
    Object.keys(campagne).forEach(function (ns) { all[ns] = campagne[ns]; });
    Object.keys(codes).forEach(function (ns) {
      all[ns] = codes[ns];
      if (codes[ns].replaces && !codes[ns].declined) delete all[codes[ns].replaces];
    });
    return all;
  }

  /*
   * Applique le code en s'appuyant sur l'API Cart AJAX (champ discount de
   * /cart/update.js) : fonctionne aussi derrière le proxy de theme dev, là où
   * la route cookie /discount/ répond 401. Cette dernière reste en fallback.
   */
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    return MGMFunnel.addDiscountCodes([code]).catch(function () {
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {});
    });
  }

  var I18N = window.MGM_I18N || { gift_property_name: 'Gift', gift_default_label: 'Free with your order' };

  function cartAdd(entitlement) {
    var properties = {};
    properties[GIFT_PROP] = entitlement.ns;
    properties[I18N.gift_property_name] = entitlement.label || I18N.gift_default_label;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(entitlement.variantId), quantity: 1, properties: properties }]
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add ' + r.status);
      return r.json();
    });
  }

  function findGiftLine(cart, entitlement) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (String(it.variant_id) === String(entitlement.variantId) && it.properties && it.properties[GIFT_PROP]) {
        return it;
      }
    }
    return null;
  }

  function mainProductInCart(cart, entitlement) {
    var items = (cart && cart.items) || [];
    var trigger = entitlement.trigger || [entitlement.mainProductId];
    for (var i = 0; i < items.length; i++) {
      if (isGiftItem(items[i])) continue;
      if (trigger === 'any' || trigger.map(String).indexOf(String(items[i].product_id)) !== -1) return true;
    }
    return false;
  }

  function paidLine(cart, entitlement) {
    if (!entitlement.accept) return null;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (!isGiftItem(items[i]) && entitlement.accept.indexOf(String(items[i].variant_id)) !== -1) return items[i];
    }
    return null;
  }

  function computeOps(cart, entitlements) {
    var ops = [];
    var seen = {};
    var adding = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var ns = giftNamespace(it);
      if (ns && seen[ns]) ops.push({ type: 'remove', key: it.key });
      if (ns) seen[ns] = true;
    });
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.variantId || !(e.mainProductId || e.trigger)) return;
      var giftLine = findGiftLine(cart, e);
      var mainIn = mainProductInCart(cart, e);
      var paid = paidLine(cart, e);
      if (mainIn && !giftLine && !paid && !e.declined) {
        if (!adding[e.variantId]) ops.push({ type: 'add', entitlement: e });
        adding[e.variantId] = true;
      } else if (giftLine && (!mainIn || paid)) {
        ops.push({ type: 'remove', key: giftLine.key });
      } else if (giftLine && giftLine.quantity > 1) {
        ops.push({ type: 'clamp', key: giftLine.key });
      }
    });
    ((cart && cart.items) || []).forEach(function (it) {
      var ns = giftNamespace(it);
      if ((ns.indexOf(CAMPAGNE_PREFIX) === 0 || ns.indexOf(CODE_PREFIX) === 0) && !entitlements[ns]) ops.push({ type: 'remove', key: it.key });
    });
    return ops;
  }

  function reconcile(cart) {
    var entitlements = allEntitlements(cart);
    var ops = computeOps(cart, entitlements);
    if (!ops.length) return Promise.resolve({ cart: cart, entitlements: entitlements, mutated: false });
    return runOps(ops).then(function () { return MGMFunnel.cart(); }).then(function (fresh) {
      return { cart: fresh, entitlements: allEntitlements(fresh), mutated: true };
    });
  }

  // Un code peut être refusé (déjà utilisé, produit non éligible) : l'article ne doit jamais rester payant.
  function dropUnpaidCodeGifts(state) {
    var refused = readRefused();
    var updates = {};
    var products = payingProducts(state.cart);
    (state.cart.items || []).forEach(function (it) {
      var ns = giftNamespace(it);
      if (ns.indexOf(CODE_PREFIX) !== 0 || !it.final_line_price) return;
      refused[ns] = products;
      updates[it.key] = 0;
    });
    if (!Object.keys(updates).length) return Promise.resolve(state);
    try { sessionStorage.setItem(REFUSED_KEY, JSON.stringify(refused)); } catch (e) {}
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function () { return MGMFunnel.cart(); }).then(reconcile).then(function (next) {
      next.mutated = true;
      return next;
    });
  }

  // Retraits groupés dans un seul /cart/update.js : un retrait peut changer la clé des autres lignes.
  function runOps(ops) {
    var updates = {};
    ops.forEach(function (op) {
      if (op.type !== 'add') updates[op.key] = op.type === 'remove' ? 0 : 1;
    });
    var chain = Object.keys(updates).length
      ? fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates })
        }).catch(function (e) {
          if (window.console && console.warn) console.warn('[MGMGift] update failed', e);
        })
      : Promise.resolve();
    ops.forEach(function (op) {
      if (op.type !== 'add') return;
      chain = chain.then(function () {
        return cartAdd(op.entitlement);
      }).catch(function (e) {
        if (window.console && console.warn) console.warn('[MGMGift] op failed', op.type, e);
      });
    });
    return chain;
  }

  /*
   * Le code n'est appliqué qu'une fois la ligne cadeau réellement au panier
   * (sinon la condition Buy X Get Y n'est pas remplie), et une seule fois par
   * chargement de page.
   */
  function ensureDiscounts(cart, entitlements) {
    var chain = Promise.resolve();
    Object.keys(entitlements).forEach(function (ns) {
      var e = entitlements[ns];
      if (!e || !e.code || e.declined || appliedCodes[e.code]) return;
      if (!findGiftLine(cart, e)) return;
      appliedCodes[e.code] = true;
      chain = chain.then(function () { return applyDiscountCode(e.code); });
    });
    return chain;
  }

  /*
   * Réconcilie panier et entitlements. Résout { changed, cart } ; `cart` est
   * le panier à jour (refetch après mutation). Les appels concurrents
   * partagent la même promesse pour éviter les doubles ajouts.
   */
  function sync(cart) {
    if (syncing) return syncing;
    if (!Object.keys(allEntitlements()).length && !window.MGMCampagne && !cart) {
      return Promise.resolve({ changed: false, cart: cart || null });
    }
    // Toujours relire le panier : un panier passé par l'appelant peut dater d'avant le dernier sync et faire ajouter les cadeaux en double.
    syncing = MGMFunnel.cart().then(reconcile).then(function (first) {
      return dropUnpaidCodeGifts(first).then(function (state) {
        var mutated = first.mutated || state.mutated;
        return ensureDiscounts(state.cart, state.entitlements).then(function () {
          if (mutated) {
            try {
              document.dispatchEvent(new CustomEvent('mgm:gift:synced', { detail: { cart: state.cart } }));
            } catch (e) {}
          }
          return { changed: mutated, cart: state.cart };
        });
      });
    }).catch(function () {
      return { changed: false, cart: cart || null };
    }).then(function (result) {
      syncing = null;
      return result;
    });
    return syncing;
  }

  function grant(opts) {
    if (!opts || !opts.ns || !opts.variantId || !opts.mainProductId) return Promise.resolve({ changed: false, cart: null });
    var entitlements = readEntitlements();
    entitlements[opts.ns] = {
      ns: String(opts.ns),
      code: String(opts.code || ''),
      variantId: String(opts.variantId),
      mainProductId: String(opts.mainProductId),
      label: String(opts.label || ''),
      declined: false,
      grantedAt: Date.now()
    };
    writeEntitlements(entitlements);
    return sync();
  }

  /* Le client a retiré son cadeau du panier : ne pas le re-ajouter. */
  function decline(ns) {
    if (String(ns).indexOf(CAMPAGNE_PREFIX) === 0 || String(ns).indexOf(CODE_PREFIX) === 0) {
      var declined = readDeclined();
      declined[ns] = true;
      try { localStorage.setItem(DECLINED_KEY, JSON.stringify(declined)); } catch (e) {}
      return;
    }
    var entitlements = readEntitlements();
    if (entitlements[ns]) {
      entitlements[ns].declined = true;
      writeEntitlements(entitlements);
    }
  }

  function isGiftItem(item) {
    return !!(item && item.properties && item.properties[GIFT_PROP]);
  }

  function codeHint(item, cart) {
    var text = '';
    ((cart && cart.discount_codes) || []).forEach(function (d) {
      var gift = CODE_GIFTS[String(d.code).toUpperCase()];
      if (gift && gift.hint && !d.applicable && String(item.variant_id) === gift.variantId && item.final_line_price) text = gift.hint;
    });
    return text;
  }

  function giftNamespace(item) {
    return isGiftItem(item) ? String(item.properties[GIFT_PROP]) : '';
  }

  /* Total (en centimes) des lignes cadeaux, à déduire de l'affichage. */
  function giftDiscountCents(cart) {
    var sum = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (isGiftItem(it)) {
        sum += it.final_line_price != null ? it.final_line_price : (it.line_price || 0);
      }
    });
    return sum;
  }

  window.MGMGift = {
    grant: grant,
    sync: sync,
    decline: decline,
    isGiftItem: isGiftItem,
    codeHint: codeHint,
    giftNamespace: giftNamespace,
    giftDiscountCents: giftDiscountCents
  };

  /* Le produit principal vient d'être ajouté : le cadeau suit immédiatement. */
  document.addEventListener('product:added-to-cart', function () { sync(); });
  document.addEventListener('mgm:codes-applied', function () {
    Promise.resolve(syncing).then(function () { return sync(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { sync(); });
  } else {
    sync();
  }
})();
